import clsx from "clsx";
import shape from "../../assets/img/shapes/circle-shape-01.webp";


const CircleShape01 = ( props:any ) => {

    return (
        <div className={clsx("rmdr-circle-shape-01", props.className)}>
            <img src={shape} alt="rmdr-circle-shape-01" loading="lazy" width={138} height={138} />
        </div>
    )

}

export default CircleShape01;
